import CryptoJS from 'crypto-js'

const hashKey = '}P~Ed}&yT<?Y8a,h'

export const encrypt = (data: string) =>
  CryptoJS.AES.encrypt(data, hashKey).toString()

export const decrypt = (data: string) =>
  CryptoJS.AES.decrypt(data, hashKey).toString(CryptoJS.enc.Utf8)
